export const TextTyper = (() => {
	'use strict';

	function init() {
		const $typers = document.querySelectorAll('[data-text-typer]')

		const doTyping = (el, textArray) => {
			let state = 'add' // add, remove, hold, next
			const delays = {
				add: 100,
				remove: 30,
				hold: 3000,
				next: 200
			}
			let wordPosition = 0
			let letterPosition = 0
			const write = () => {
				el.innerText = `${textArray[wordPosition].substring(0, letterPosition)}`
			}
			const next = () => {
				if (!document.body.contains(el)) {
					return
				} else if (state == 'add') {
					letterPosition++
					if (textArray[wordPosition][letterPosition] == ' ') {
						letterPosition++
					}
					write()
					state = letterPosition >= textArray[wordPosition].length ? 'hold' : 'add'
				} else if (state == 'remove') {
					letterPosition--
					write()
					state = letterPosition <= 0 ? 'next' : 'remove'
				} else if (state == 'hold') {
					state = 'remove'
				} else if (state == 'next') {
					state = 'add'
					wordPosition = (wordPosition + 1) % textArray.length // set next word
				}
				setTimeout(next, delays[state])
			}
			el.id = 'word-typer'
			next()
		}

		if ($typers.length) {
			for (let $typer of $typers) {
				const $spans = [...$typer.children]
				if ($spans.length) {
					let rotateText = []
					for (let i = 1; i < $spans.length; i++) {
						rotateText.push($spans[i].innerText)
						$spans[i].remove()
					}
					const $typeEl = $spans[1]
					$typeEl.innerText = ''
					$typer.append($typeEl)
					doTyping($typeEl, rotateText)
				}
			}
		}

	}

	return {
		init: init,
		name: 'text-typer'
	};
})();
